module.exports = {
  title: 'Atlas Button with React Native Skia 🪄',
  author: 'Enzo Manuel Mangano',
  date: '2024-06-18',
  slug: 'atlas-button',
  tags: ['skia'],
};
